import validate from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/validate.js";
import app_45native_45shell_45global from "/vercel/path0/middleware/appNativeShell.global.ts";
import clear_45aff_45link_45on_45partners_45global from "/vercel/path0/middleware/clearAffLinkOnPartners.global.ts";
import clear_45partners_45sub_45code_45off_45partners_45global from "/vercel/path0/middleware/clearPartnersSubCodeOffPartners.global.ts";
import error_45global from "/vercel/path0/middleware/error.global.ts";
import partners_45redirect_45global from "/vercel/path0/middleware/partnersRedirect.global.ts";
import manifest_45route_45rule from "/vercel/path0/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  app_45native_45shell_45global,
  clear_45aff_45link_45on_45partners_45global,
  clear_45partners_45sub_45code_45off_45partners_45global,
  error_45global,
  partners_45redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/vercel/path0/middleware/auth.ts"),
  "kakao-pixel": () => import("/vercel/path0/middleware/kakaoPixel.ts"),
  login: () => import("/vercel/path0/middleware/login.ts"),
  "naver-ads": () => import("/vercel/path0/middleware/naverAds.ts"),
  "order-success-guard": () => import("/vercel/path0/middleware/orderSuccessGuard.ts"),
  partners: () => import("/vercel/path0/middleware/partners.ts"),
  "post-purchase-guard": () => import("/vercel/path0/middleware/postPurchaseGuard.ts")
}